import { IEirSalesAscertain } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAscertain";
import { IEirSalesSaveAscertainPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveAscertainPayload";
import { mapEirSalesAscertain } from "@modules/eirSalesFacade/mappers/mapEirSalesAscertain";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getAscertainRoute } from "@api-routes/eirSalesFacade";

export const postSaveAscertain = (
    prospectReference: string,
    offerId: number,
    payload: IEirSalesSaveAscertainPayload,
    options: IFetchOptions = {}
) =>
    fetcher<IEirSalesAscertain>(getAscertainRoute(prospectReference, offerId), {
        method: "POST",
        body: payload,
        mapper: mapEirSalesAscertain,
        ...options,
    });
